import React, { useState, useEffect } from 'react'

const FloatingWhatsApp: React.FC = () => {
	const [isVisible, setIsVisible] = useState(false)
	const [isHovered, setIsHovered] = useState(false)

	const whatsappNumber = '+573225432580'
	const message =
		'Hola! Me interesa conocer más sobre los productos de SportCenter Shop 💪'

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(true)
		}, 1000)
		return () => clearTimeout(timer)
	}, [])

	const openWhatsApp = () => {
		const encodedMessage = encodeURIComponent(message)
		const whatsappURL = `https://wa.me/${whatsappNumber.replace(
			/[^0-9]/g,
			''
		)}?text=${encodedMessage}`
		window.open(whatsappURL, '_blank')
	}

	return (
		<div
			className={`fixed z-[999] bottom-52 sm:bottom-56 right-4 lg:bottom-32 lg:right-6 transform transition-all duration-500 ease-out ${
				isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'
			}`}
		>
			{isHovered && (
				<div className='absolute bottom-full right-0 mb-3 transform transition-all duration-300 ease-out animate-in fade-in slide-in-from-bottom-2'>
					<div className='bg-gray-900 text-white px-4 py-2 rounded-2xl text-sm font-medium whitespace-nowrap relative'>
						¡Chatea con nosotros en WhatsApp!
						<div className='absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900'></div>
					</div>
				</div>
			)}

			<button
				onClick={openWhatsApp}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
				className='w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 cursor-pointer bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group relative overflow-hidden hover:scale-110 active:scale-95'
				aria-label='Abrir WhatsApp'
			>
				<div className='absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000'></div>

				<div className='relative z-10'>
					<svg
						className='w-7 h-7 transition-transform duration-300 group-hover:scale-110'
						fill='currentColor'
						viewBox='0 0 24 24'
					>
						<path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516' />
					</svg>
				</div>

				<div className='absolute inset-0 rounded-full border-2 border-green-400 animate-ping opacity-30'></div>

				<div className='absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full border-2 border-green-500 flex items-center justify-center'>
					<div className='w-2 h-2 bg-green-500 rounded-full animate-pulse'></div>
				</div>
			</button>
		</div>
	)
}

export default FloatingWhatsApp
